import * as yup from 'yup';

export const AddPropertySchema = yup.object().shape({
    address: yup.string().required('Property Address is required'),
    parcelNumber: yup.string().required('Parcel Number is required'),
    startingBid: yup.string().required('Starting Bid is required'),
    bedCount: yup.string().required('Beds is required'),
    bathCount: yup.string().required('Baths is required'),
    lat: yup.number().required('Latitude is required'),
    lng: yup.number().required('Longitude is required'),
    description: yup.string(),
    images: yup.string()
});
